export default __webpack_public_path__ + "static/media/stars-white.61428f0a.svg";